import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { InlineFieldInterfaceComponent } from '../inline-field-interface.component';
import { PartialFormField } from '../../form-fields/form-field.types';
import { FieldDef } from 'app/core/models';
import moment from 'moment';

@Component({
  templateUrl: './date-inline-field.component.html',
})
export class DateInlineFieldComponent implements InlineFieldInterfaceComponent, OnInit {
  @Input() model: any;
  @Input() fieldDef: FieldDef;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly = false;
  @Input() canClick: boolean = false;
  @Output() onClick: EventEmitter<PartialFormField> = new EventEmitter();
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  value = '';
  displayValue: Date;

  ngOnInit(): void {
    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];
    if (this.value && this.value !== 'REDACTED') {
      this.displayValue = moment(this.value).toDate();
    }
  }

  clickField($event) {
    this.onClick.emit($event);
  }
}
